import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import footerdd from "../assets/footerdd.png";
import footerlogo from "../assets/footerlogo.png";
import footerlogo2 from "../assets/footer_img_2.jpg"
import Footerink from "../assets/Footerink.png";

import '../../src/components/styles/Footer.css';
import "bootstrap/dist/css/bootstrap.min.css";
import iconvecter from "../assets/iconvecter.png"; 
const Footer = () => {
  return (
    <footer className="text-white  ">
                    <img src={footerlogo2} alt="Ez Puja Path" className="img-fluid w-100 d-block d-md-none" />

      <div style={{ backgroundImage: `url(${footerdd})`, backgroundSize: "cover", backgroundPosition: "center" }} >
        <div className=" p-4" >
          <div className="row align-items-center  d-flex flex-wrap">
            <div className="col-sm-3 text-center mb-3 mb-sm-0">
              <img src={footerlogo} alt="Ez Puja Path" className="img-fluid d-none d-md-block" style={{ height: '287px', width: '287px' }} />
            </div>
            <div className="col-sm-9 p-4">
              <div className="row text-center text-sm-start gap-3 rrespo">
                {[
                  { title: "✅ Available from Early Morning to Late Night", text: "Book your puja at your preferred time." },
                  { title: "✅ Regional Pandits", text: "Multi-language Pandits available for all traditions." },
                  { title: "✅ Affordable Dakshina", text: "Transparent pricing with flexible offerings." },
                  { title: "✅ 24x7 Support", text: "Need help? Contact us anytime!" }
                ].map((item, index) => (
                  <div key={index} className="col-md-2 footerborder mb-3">
                    <p className="footertext">{item.title}</p>
                    <p className="ptagtext">{item.text}</p>
                  </div>

                ))}
              </div>

              <p className="mt-3 text-center text-sm-start" style={{ color: '#F2CD4B' }}>
                <strong style={{ color: '#fff' }}>Ez Puja Path - Your Trusted Online Puja Partner</strong><br />
                At Ez Puja Path, we provide expert Pandit Ji services across India, conducting authentic Vedic rituals under the guidance of experienced priests. You can perform your desired puja from the comfort of your home and receive divine blessings hassle-free.
              </p>
            </div>
          </div>
        </div>

        {/* Navigation Links */}
        <div className=" p-4 mt-4 ">
          <div className="row col-sm-12 d-flex flex-wrap">
            <div className="col-sm-2">
              <h5>Account Section</h5>
              <ul className="list-unstyled">
                {[
                  { text: "Login", link: "/login" },
                  { text: "Register", link: "/Register" },
                  { text: "Order History", link: "/Profile" },
                  { text: "Track Delivery", link: "/Profile" }
                ].map((item, index) => (
                  <li key={index} style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                    <img src={iconvecter} alt="Icon" style={{ width: "10px", height: "25px", objectFit: "contain" }} />
                    <a href={item.link} className="custom-link">{item.text}</a>
                  </li>
                ))}
              </ul>

            </div>
            <div className="col-sm-2">
              <h5>Quick Link</h5>
              <ul className="list-unstyled">
                {[
                  { text: "Know Your Pandit", link: "/pandit" },
                  { text: "About Us", link: "/about" },
                  { text: "e-Puja", link: "/epuja" },
                  { text: "Puja Service", link: "/puja-service" }
                ].map((item, index) => (
                  <li key={index} style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                    <img src={iconvecter} alt="Icon" style={{ width: "10px", height: "25px", objectFit: "contain" }} />
                    <a href={item.link} className="custom-link">{item.text}</a>
                  </li>
                ))}
              </ul>

            </div>
            <div className="col-sm-2">
  <h5>Reach Helpdesk</h5>

  <ul className="list-unstyled">
    {[
      {
        text: "Call Us",
        link: "tel:+910123456789"
      },
      {
        text: "Support",
        link: "https://wa.me/910123456789"
      },
      {
        text: "Email Us",
        link: "mailto:info@yourdomain.com"
      },
      {
        text: "Contact Us",
        link: "/contact"
      }
    ].map((item, index) => (
      <li
        key={index}
        style={{
          display: "flex",
          gap: "12px",
          alignItems: "center"
        }}
      >
        <img
          src={iconvecter}
          alt="Icon"
          style={{
            width: "10px",
            height: "25px",
            objectFit: "contain"
          }}
        />

        <a
          href={item.link}
          className="custom-link"
          target={
            item.text === "Support" ? "_blank" : undefined
          }
          rel={
            item.text === "Support"
              ? "noopener noreferrer"
              : undefined
          }
        >
          {item.text}
        </a>
      </li>
    ))}
  </ul>
</div>
            <div className="col-sm-2">
              <h5>Information</h5>
              <ul className="list-unstyled">
                {[
                  { text: "Cookies Policy", link: "/cookies-policy" },
                  { text: "Privacy Policy", link: "/privacy-policy" },
                  { text: "Terms & Conditions", link: "/terms-conditions" },
                  { text: "Refund Policy", link: "/refund-policy" }

                ].map((item, index) => (
                  <li key={index} style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                    <img src={iconvecter} alt="Icon" style={{ width: "10px", height: "25px", objectFit: "contain" }} />
                    <a href={item.link} className="custom-link">{item.text}</a>
                  </li>
                ))}
              </ul>

            </div>
            <div className="col-sm-4">
              <div className="input-group mb-3 w-100 mx-auto">
                <input type="email" className="form-control" placeholder="Enter your email" />
                <button className="btn btn-warning">Subscribe</button>
              </div>
              <div className="d-flex justify-content-center  gap-2 text-white bord">
                <div>
                  <p className="ptagg">Follow Us On Our Social Media</p>
                </div>
                <div className="d-flex justify-content-center gap-4 text-white fs-4">
                  <FaFacebookF className="cursor-pointer" />
                  <FaInstagram className="cursor-pointer" />
                  <FaTwitter className="cursor-pointer" />
                  <FaLinkedin className="cursor-pointer" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Logo and Key Features */}
      <div className="p-4" style={{ backgroundImage: `url(${Footerink})`, backgroundSize: "cover", backgroundPosition: "center" }}>
        <div className="row col-sm-12">
          <div className="col-sm-2">
            <p className="lishow">Type of Pandit</p>
            <ul className="list-unstyled">
              {[
                { text: "Arya Samaj Pandit Ji" },
                { text: "Hindu Vedic Pandit Ji" },
                { text: "Marathi Pandit Ji" },
                { text: "Telugu Purohits Ji" },
                { text: "Kannada Pujari Ji" },
                { text: "Malayalam Pandit Ji" },
                { text: "Odiya Purohits Ji" },
                { text: "South Indian Pandit Ji" }
              ].map((item, index) => (
                <li key={index} style={{ display: "flex", gap: "12px" }}>
                  <img src={iconvecter} alt="Icon" style={{ width: "10px", height: "25px", objectFit: "contain" }} />
                  <a href={item.link} className="custom-link">{item.text}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-sm-2">
            <p className="lishow">Area Specific</p>
            <ul className="list-unstyled">
              {[
                { text: "Pandit Ji In Andheri" },
                { text: "Pandit Ji In Borivali" },
                { text: "Pandit Ji In Dahisar" },
                { text: "Pandit Ji In Kalyan" },
                { text: "Pandit Ji In Dadar" },
                { text: "Pandit Ji In Bandra" },
                { text: "Pandit Ji In Colaba" },
                { text: "Pandit Ji In Lonavala" }
              ].map((item, index) => (
                <li key={index} style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                  <img src={iconvecter} alt="Icon" style={{ width: "10px", height: "25px", objectFit: "contain" }} />
                  <a href={item.link} className="custom-link">{item.text}</a>
                </li>
              ))}
            </ul>

          </div>
          <div className="col-sm-2">
            <p className="lishow">Area Specific</p>
            <ul className="list-unstyled">
              {[
                { text: "Pandit Ji In Navi Mumbai" },
                { text: "Pandit Ji In Nerul" },
                { text: "Pandit Ji In Ulwe" },
                { text: "Pandit Ji In Belapur" },
                { text: "Pandit Ji In Seawood" },
                { text: "Pandit Ji In Uran" },
                { text: "Pandit Ji In Bhiwandi" },
                { text: "Pandit Ji In Turbe" }
              ].map((item, index) => (
                <li key={index} style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                  <img src={iconvecter} alt="Icon" style={{ width: "10px", height: "25px", objectFit: "contain" }} />
                  <a href={item.link} className="custom-link">{item.text}</a>
                </li>
              ))}
            </ul>

          </div>
          <div className="col-sm-2">
            <p className="lishow">Area Specific</p>
            <ul className="list-unstyled">
              {[
                { text: "Pandit Ji In Matheran" },
                { text: "Pandit Ji In Kurla" },
                { text: "Pandit Ji In Ghatkoper" },
                { text: "Pandit Ji In Churchgate" },
                { text: "Pandit Ji In CSTM" },
                { text: "Pandit Ji In Thane" },
                { text: "Pandit Ji In Vashi" },
                { text: "Pandit Ji In Wadala" }
              ].map((item, index) => (
                <li key={index} style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                  <img src={iconvecter} alt="Icon" style={{ width: "10px", height: "25px", objectFit: "contain" }} />
                  <a href={item.link} className="custom-link">{item.text}</a>
                </li>
              ))}
            </ul>

          </div>
          <div className="col-sm-2">
            <p className="lishow">Area Specific</p>
            <ul className="list-unstyled">
              {[
                { text: "Pandit Ji In Virar" },
                { text: "Pandit Ji In Vasai" },
                { text: "Pandit Ji In Mira Road" },
                { text: "Pandit Ji In Palghar" },
                { text: "Pandit Ji In Juhu" },
                { text: "Pandit Ji In Goregaon" },
                { text: "Pandit Ji In Lokhandwala" },
                { text: "Pandit Ji In Malad" }
              ].map((item, index) => (
                <li key={index} style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                  <img src={iconvecter} alt="Icon" style={{ width: "10px", height: "25px", objectFit: "contain" }} />
                  <a href={item.link} className="custom-link">{item.text}</a>
                </li>
              ))}
            </ul>

          </div>
          <div className="col-sm-2">
            <p className="lishow">Temple Service</p>
            <ul className="list-unstyled">
              {[
                { text: "Puja In Trimbkeshwar" },
                { text: "Puja In Ganesha Temple" },
                { text: "Puja In Vishnu Temple" },
                { text: "Puja In Laxmi Temple" },
                { text: "Puja In Shiv Temple" },
                { text: "Puja In Durga Temple" },
                { text: "Puja In Dattatreya Temple" },
                { text: "Puja In Any Temple" }
              ].map((item, index) => (
                <li key={index} style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                  <img src={iconvecter} alt="Icon" style={{ width: "10px", height: "25px", objectFit: "contain" }} />
                  <a href={item.link} className="custom-link">{item.text}</a>
                </li>
              ))}
            </ul>

          </div>
        </div>
        {/* Copyright */}
        <div className="mt-5 " style={{ display: 'flex', justifyContent: "space-around", alignItems: 'center', borderTop: '1px solid white',flexWrap:'wrap' }}>
          <div className="mt-3">
            <p>© 2026 ezpujapath.com All Rights Reserved.</p>
          </div>
          <div className="mt-3">
            <p>Design & Developed By THYO India</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
